/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getUserInfo } from "@/lib/token";
import { getCurrentTimeZone } from "@/lib/utils";
import { apiServices } from "@/services/api.services";
import { email_read_logs } from "@/services/global.services";
import { useToast } from "@/hooks/use-toast";
import { useEffect, useMemo, useState } from "react";

export const useEmailStats = (logId?: string) => {
  const API_SERVICE = email_read_logs;
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);
  const timeZone = getCurrentTimeZone();
  const { toast } = useToast();
  const [loading, setLoading] = useState(true);
  const [emailStats, setEmailStats] = useState<any[]>([]);

  useEffect(() => {
    if (!logId || logId === "undefined") {
      setLoading(false);
      return;
    }
    (async () => {
      const payload = {
        data: {
          filter_by: {
            log_id: logId,
            pagination: {
              page_no: 1,
              no_of_recs: 1,
              sort_by: "cts",
              order_by: false,
            },
          },
        },
        company_id,
        user_id,
        timezone: timeZone,
      };

      const { data, error, message } = await apiServices<any>(
        API_SERVICE.get,
        "post",
        payload
      );

      if (data) {
        const items = data.result.metadata?.[API_SERVICE.key];
        if (items && items.length > 0) {
          setEmailStats(items[0].email_stats || []);
        }
      }

      if (error) {
        toast({
          title: "Error",
          variant: "destructive",
          description: error.status?.message || message,
        });
      }

      setLoading(false);
    })();
  }, [logId]);

  return { emailStats, loading };
};
